var isSymbol = require('../internals/is-symbol');

module.exports = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/to-string.js